<template>
    <div class="c-select-filter">
        <Select2 v-model="selectedValues" :options="selectOptions"
                 :settings="{ multiple: true, placeholder: placeholder, escapeMarkup: escapeMarkUp }"
                 @select="updateSelectedValue($event)"/>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component'
    import axios from 'axios'

    export default {
        name: "SelectFilter",
        props: {
            taxonomy: {
                type: String,
                required: true
            },
            placeholder: {
                type: String,
                default() {
                    return 'Select options'
                }
            },
        },
        components: {
            Select2
        },
        data() {
            return {
                selectedValues: [],
                selectOptions: []
            }
        },
        mounted() {
            this.populateOptions()
        },
        methods: {
            escapeMarkUp(text) {
                // ensures html entities are escaped in the options that are listed
                return text
            },
            urlParamsUpdate() {
                // Used to prepopulate the select values after reload
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)

                if (urlParams.has(this.taxonomy)) {
                    this.selectedValues = urlParams.get(this.taxonomy).split(',')
                    this.updateSelectedValue()
                }
            },
            async populateOptions() {
                await axios.get(window.ajax.url, {
                    params: {
                        action: 'basethemeSelect2AvailableOptions',
                        taxonomy: this.taxonomy,
                    }
                }).then((response) => {
                    this.selectOptions = response.data.options
                    // decode any html entities entered
                    this.urlParamsUpdate()

                    this.$store.commit('updateLoadingStatus', {
                        name: this.taxonomy,
                        status: false
                    });
                }).catch((error) => {
                    alert('There was error in fetching events')
                })

            },
            updateSelectedValue() {
                // Updates selected values for the dropdowns in the VueX store found in src/vue/store/state.js
                if (this.selectedValues.length > 0) {
                    this.$store.commit('updateField', {
                        name: this.taxonomy,
                        value: this.selectedValues
                    });
                } else {
                    this.$store.commit('updateField', {
                        name: this.taxonomy,
                        value: null
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
